import React from "react";
import { IconProps } from "../icon";

export const ArrowCircleBrokenUpIcon = ({ size = "24px", color = "#000", ...props }: IconProps<string, string>) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path
      stroke={color}
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="2"
      d="M7 20.662A9.996 9.996 0 012 12C2 6.477 6.477 2 12 2s10 4.477 10 10a9.996 9.996 0 01-5 8.662M16 12l-4-4m0 0l-4 4m4-4v14"
    />
  </svg>
);
